import { Link } from "@at/design-system-elements";
import { ThemeSelectors } from "@at/design-system-foundation";
import { BREAKPOINTS } from "@at/window-utils/lib/responsive-utils/match-media.util";
import styled, { css } from "styled-components";

import { MobilePadding } from "../advert/advert-overview.styles";
import { PrintStyleSheet } from "../seller/advert-seller-details/location/location.styles";

// TODO: Update colors to use ATDS
export const BuyingSafelyDigitalRetailerContainer = styled.div`
  ${MobilePadding}

  a {
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  ${({ theme }) => css`
    padding-bottom: 8px;
    padding: 16px 0;
    border-bottom: 1px solid ${ThemeSelectors.getGrey(theme)};

    &:hover + span ~ svg {
      fill: red;
    }
  `}
  ${PrintStyleSheet}
`;

export const BuyingSafelyTitleDigitalRetailer = styled.div`
  padding-bottom: 0;
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
  position: relative;
  width: 100%;
`;
export const Arrow = styled.span`
  float: right;
  padding-top: 4px;
  svg,
  svg path {
    fill: currentColor;
  }
`;

export const BuyingSafelyCopy = styled.div`
  ${({ theme }) => css`
    color: ${ThemeSelectors.getCopyColor(theme)};
    a {
      &:hover {
        cursor: pointer;
      }
    }
  `}
`;

export const BuyingSafelyReportAdvert = styled.div`
  ${({ theme }) => `
        color: ${ThemeSelectors.getCopyColor(theme)};
        margin: ${ThemeSelectors.getGroupFiveSpacing(theme)} 0 0;
        ${PrintStyleSheet}
    `}
`;
export const BuyingSafelyReportAdvertButton = styled(Link).attrs({
  renderAsButton: true,
})`
  ${({ theme }) => css`
    border: none;
    text-decoration: underline;
    text-underline-offset: ${ThemeSelectors.getGroupOneSpacing(theme)};
    text-decoration-thickness: 1px;
    font-size: inherit;
    position: relative;
    padding-left: 26px;
    ${PrintStyleSheet}

    @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
      margin-left: calc(${ThemeSelectors.getGridUnit(theme)} * 0.5);
    }

    @media print {
      display: none;
    }

    .icon-svg {
      display: inline-block;
      position: relative;
      width: 24px;
      height: 24px;
      margin: ${({ theme }) =>
        `0 calc(${ThemeSelectors.getGridUnit(theme)} / 4) 0 0`};
      vertical-align: middle;
    }

    svg {
      position: absolute;
      top: -2px;
      left: 0;
      fill: currentColor;
    }
  `}
`;

export const BuyingSafelySuccessIcon = styled.span`
  display: flex;
  flex-flow: column;
  align-items: center;
  margin: 40px 0;
  ${() => `
        svg {
            width: 167px;
            height: 168px;
        }
    `}
`;
export const ErrorMessage = styled.p`
  color: RED;
`;
export const CTAButtonWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-top: 48px;

  .atds-button {
    min-width: 40%;
    margin: 0 0 calc(${({ theme }) => ThemeSelectors.getGridUnit(theme)} * 2);
  }
`;
export const CenteredContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;
export const CenteringWriting = styled.p`
  flex-grow: 1;
  display: flex;
  align-self: center;
  align-items: center;
  max-width: 288px;
`;
export const Title = styled.span`
  display: flex;
  flex-flow: column;
  align-items: center;
`;
export const ReportAdRadioOptions = styled.div`
  .report-ad__label {
    display: block;
    font-size: 14px;
    color: #666;
    font-weight: ${({ theme }) => ThemeSelectors.getMediumFontWeight(theme)};
    font-variation-settings: "wght"
      ${({ theme }) => ThemeSelectors.getMediumFontWeight(theme)};
    -webkit-font-smoothing: antialiased;
    margin: 8px 0;
    padding: 8px 8px;
    background: #f7f7f5;
    border-radius: 4px;
    position: relative;

    &[for="OTHER8"] {
      margin-bottom: ${({ theme }) =>
        ThemeSelectors.getGroupFourSpacing(theme)};
    }
  }
  .report-ad__label--active {
    background: #e8e8e3;
  }
  .report-ad__subtext {
    color: #999;
    font-size: 0.77em;
    font-weight: ${({ theme }) => ThemeSelectors.getRegularFontWeight(theme)};
    font-variation-settings: "wght"
      ${({ theme }) => ThemeSelectors.getRegularFontWeight(theme)};
    -webkit-font-smoothing: antialiased;
    display: block;
    padding: 0 8px 0 32px;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .report-ad__input:checked {
    background: #06a09d;
  }
  .report-ad__input {
    width: 24px;
    height: 24px;
    margin: 0 8px 0 0;
    background: #fff;
    border-radius: 50%;
    vertical-align: middle;
    appearance: none;
    border: none;
    position: relative;
    border-radius: 50%;
    float: left;
  }
  h4 {
    margin-top: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  }
`;

export const AdditionalInfoWrapper = styled.div`
  textarea {
    min-height: 70px;
  }
`;
